import React from '/web_modules/react.js';

function App() {
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-blue-900 w-screen h-screen flex items-center justify-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-6xl text-white"
  }, "Tailwind Works"));
}

export default App;
